// NOTE: Maybe a service could handle "title pieces array"
const formatDocumentTitle = (titlePieces) => {
  const SEPARATORS = [
    '::',
    '·',
  ];

  return titlePieces.reduceRight((str, piece, index) => {
    const separator = SEPARATORS[index % SEPARATORS.length];

    return `${str} ${separator} ${piece}`;
  });
};

export default (baseTitle = '') => (
  (to, from, next) => {
    const routeTitles = to.matched.map((route) => route.meta.titleLocalePath);

    const titlePieces = [baseTitle, ...routeTitles].filter((str) => !!str);

    document.title = formatDocumentTitle(titlePieces);

    next();
  }
);
